import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BetslipPage } from './betslip';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    BetslipPage
  ],
  imports: [
    TranslateModule,
    IonicPageModule.forChild(BetslipPage),
  ],
  exports: [
    BetslipPage
  ]
})
export class BetslipPageModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/betslip/betslip.module.ts